export const debounce = (func: CallableFunction, wait: number) => {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    return function () {
        const callback = function () {
            timeout = undefined;
            func();
        };
        clearTimeout(timeout);
        timeout = setTimeout(callback, wait);
    };
};
